import React from 'react';
import { render } from 'react-dom';
import App from './Components/App';
import './styles/index.css';

render(<App />, document.getElementById('root'));
